module.exports = __webpack_public_path__ + "static/media/lb-next.94513e7d.svg";